import { DateFieldType } from "shared/types/FormFieldTypes";
import FloatingInputWrapper from "shared/components/layouts/FloatingInputWrapper";

const DateInput = ({ placeholder, id }: DateFieldType) => {
  return (
    <FloatingInputWrapper id={id} placeholder={placeholder} shrink={false}>
      {/* DateInput component here */}
    </FloatingInputWrapper>
  );
};

export default DateInput;
